import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class StatePreferenceApi {
  addStatePreference(data, config) {
    return axios.post(`${baseUrl}/state/add`, data, config)
  }
  getAllState(query) {
    return axios.get(`${baseUrl}/state/all`, query)
  }

  updateStatePreference(data, query) {
    return axios.put(`${baseUrl}/state/preference`, data, query)
  }

  searchState(params, query) {
    return axios.get(`${baseUrl}/state/search`, { params, ...query })
  }
}

export default new StatePreferenceApi()
